
export default {
  props: {
    pageButtonNum: {
      type: Number,
      default: 5
    }
  },
  computed: {
    hasButtonPaging() {
      return this.pageButtonNum < this.totalPagesNum
    },
    nextDisable() {
      return this.totalPagesNum && this.currentPage === this.totalPagesNum - 1
    },
    previousDisable() {
      return this.totalPagesNum && this.currentPage === 0
    },
    pageButtonItems() {
      if (this.totalPagesNum <= this.pageButtonNum) return _.times(this.totalPagesNum, (idx) => idx)
      else {
        const centerNum = Math.ceil(this.pageButtonNum / 2)
        let result, numButtonCount = this.pageButtonNum - 1
        // 현재페이지가 3 이하인 경우
        if (this.currentPage + 1 <= centerNum) {
          result = _.times(numButtonCount, (idx) => idx)
          result.push(this.totalPagesNum - 1)
        }
        // 현재페이지가 토탈 - 3 이상인경우
        else if (this.currentPage >= this.totalPagesNum - centerNum) {
          result = [0]
          _.times(numButtonCount, (idx) => result.push(this.totalPagesNum - (numButtonCount - idx)))
        }
        // 아닌경우
        else {
          let numButtonCount = this.pageButtonNum - 2
          let loopStartNum = this.currentPage - Math.floor(numButtonCount / 2)
          result = [0, ..._.times(numButtonCount, (idx) => loopStartNum + idx), this.totalPagesNum - 1]
        }
        return result
      }
    }
  },
  methods: {
    onClickPageButton(pageNum) {
      if ( pageNum < 0 || pageNum > this.totalPagesNum - 1) return
      this.currentPage = pageNum
    }
  }
}